export const API_GET_DEPOSIT_PLACES = "API_GET_DEPOSIT_PLACES";
export const API_GET_DEPOSIT_PLACES_SUCCESS = "API_GET_DEPOSIT_PLACES_SUCCESS";
export const API_GET_DEPOSIT_PLACES_FAIL = "API_GET_DEPOSIT_PLACES_FAIL";

export const API_GET_DEPOSIT_SAMPLERS = "API_GET_DEPOSIT_SAMPLERS";
export const API_GET_DEPOSIT_SAMPLERS_SUCCESS = "API_GET_DEPOSIT_SAMPLERS_SUCCESS";
export const API_GET_DEPOSIT_SAMPLERS_FAIL = "API_GET_DEPOSIT_SAMPLERS_FAIL";

export const API_PUT_DEPOSIT = "API_PUT_DEPOSIT";
export const API_PUT_DEPOSIT_SUCCESS = "API_PUT_DEPOSIT_SUCCESS";
export const API_PUT_DEPOSIT_FAIL = "API_PUT_DEPOSIT_FAIL";

export const API_DELETE_DEPOSIT = "API_DELETE_DEPOSIT";
export const API_DELETE_DEPOSIT_SUCCESS = "API_DELETE_DEPOSIT_SUCCESS";
export const API_DELETE_DEPOSIT_FAIL = "API_DELETE_DEPOSIT_FAIL";
